const ReadMoreScroll = function() {
    const readMoreLinkEl = document.getElementById("category-page__read-more__link");
    if (readMoreLinkEl) {
        readMoreLinkEl.onclick = function(ev) {
            /**
             *
             * @type {HTMLElement}
             */
            const headerEl = document.querySelector("header.header");
            const headerHeight = headerEl.offsetHeight;
            const staticOffset = 30;

            const readMoreEl = document.querySelectorAll("#category-page__read-more,#reseller-page__read-more");

            if (!readMoreEl.length) {
                return;
            }

            const y = readMoreEl[0].getBoundingClientRect().top + window.scrollY - headerHeight - staticOffset;

            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }
}

export default ReadMoreScroll;
